const tabInfo = [
    {
        label: 'ABOUT',
        value: 0,
        route: '#about',
    },
    {
        label: 'EXPERIENCE',
        value: 1,
        route: '#experience',
    },
    {
        label: 'PROJECTS',
        value: 2,
        route: '#projects',
    },
    {
        label: 'CONTACT',
        value: 3,
        route: '#contact',
    }
];

module.exports = {
    tabInfo,
};
